import { createWithEqualityFn } from 'zustand/traditional'

import Channel from '@/shared/classes/channels/channel'
import { createJSONStorage, persist } from 'zustand/middleware'
import { persistStorage } from '@/shared/state/dataBase/persistStorage'
import { ChannelProps } from '@/types/tv/channels/Channel'

export interface TvState {
    isStoreHydrated: boolean
    isTvPlaying: boolean
    selectedChannel: ChannelProps | null
    channelsData: Channel[]
    whatNextId: string
    isPIPMode: boolean
    displayNextButton: boolean
    favoriteChannels: string[]

    setIsStoreHydrated: () => void
    setSelectedChannel: (channel: ChannelProps | null) => void
    setWhatNextId: (channelId: string) => void
    setChannelsData: (channelsList: Channel[]) => void
    setIsPIPMode: (value: boolean) => void
    setDisplayNextButton: (value: boolean) => void
    setFavoriteChannels: (favChannels: string[]) => void
    clearTvStore: () => void
    setIsTVPlaying: (value: boolean) => void
}

export const useTVStore = createWithEqualityFn<TvState>()(
    persist(
        (set) => ({
            isStoreHydrated: false,
            isTvPlaying: false,
            selectedChannel: null,
            channelsData: [],
            whatNextId: '',
            isPIPMode: false,
            displayNextButton: false,
            favoriteChannels: [],

            setIsStoreHydrated: () => {
                set(() => ({
                    isStoreHydrated: true,
                }))
            },
            setIsTVPlaying: (value: boolean) => {
                set(() => ({
                    isTvPlaying: value,
                }))
            },
            setSelectedChannel: (channel: ChannelProps | null) => {
                set(() => ({
                    selectedChannel: channel,
                }))
            },
            setWhatNextId: (channelId: string) => {
                set(() => ({
                    whatNextId: channelId,
                }))
            },
            setChannelsData: (channelsList: Channel[]) =>
                set({ channelsData: channelsList }),
            setIsPIPMode: (value: boolean) => set(() => ({ isPIPMode: value })),
            setDisplayNextButton: (value: boolean) =>
                set(() => ({ displayNextButton: value })),
            setFavoriteChannels: (favChannels: string[]) =>
                set(() => ({ favoriteChannels: favChannels })),
            clearTvStore: () =>
                set(() => ({
                    channelsData: [],
                    favoriteChannels: [],
                    displayNextButton: false,
                    isPIPMode: false,
                    whatNextId: '',
                    selectedChannel: null,
                })),
        }),

        {
            name: 'tv-storage',
            storage: createJSONStorage(() => persistStorage),
            onRehydrateStorage: (state) => {
                if (state) state.setIsStoreHydrated()
            },
        }
    )
)
